import { api } from "../api";

export default async function interactAnalysis(
  encodedId: string,
  interaction: "like" | "dislike"
): Promise<number> {
  try {
    const { status } = await api.post(
      `/analysis/${encodedId}/report/interact`,
      {
        interaction,
      }
    );

    return status;
  } catch (err) {
    console.error(err);

    return 500;
  }
}
